import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Image,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Tab,
  Fade,
  Text,
  Stack,
  VStack,
  SimpleGrid,
} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';

import corporateresponsibilityHero from '../../components/ui/corporateresponsibility/Corporate-Responsibility-Overview-opt.jpeg';
import HeroWithRightMedia from '../../components/sections/herowithrightmedia';
import HeroWithLeftMedia from '../../components/sections/herowithleftmedia';
import GridCard from '../../components/sections/gridcard';

import timBoyle from '../../components/ui/corporateresponsibility/timBoyle.jpeg'
import abelNavarrete from '../../components/ui/corporateresponsibility/abelNavarrete.png'
import mountainHardwearCard from '../../components/ui/corporateresponsibility/2021_02_MHW_S21_day5-2488.jpeg'
import columbiaCard from '../../components/ui/corporateresponsibility/2021-02_Columbia_TK_F21_Titanium-2497.jpeg'
import pranaCard from '../../components/ui/corporateresponsibility/Image-9-opt.jpeg'
import sorelCard from '../../components/ui/corporateresponsibility/Sorel-W20_Tivoli_IV_Can_31782_R1.jpeg'
import snowMountainCard from '../../components/ui/corporateresponsibility/Image-4-opt-1.jpeg'
import waterCard from '../../components/ui/corporateresponsibility/Image-5-opt.jpeg'
import forestCard from '../../components/ui/corporateresponsibility/Image-6-opt.jpeg'
import greenMountainCard from '../../components/ui/corporateresponsibility/Image-7-opt.jpeg'
import trailHikeCard  from '../../components/ui/corporateresponsibility/S22_TRAIL_COOL-PROTECTED_OR_TK_2964_CA_SWAP.jpeg'
import waterfallCard from '../../components/ui/corporateresponsibility/S22_TRAIL_DRY_OR_TK_6867.jpeg'



export default function OurCorporateResponsibilities() {
  const tabMap = useMemo(
    () =>
      new Map([
        [0, 'tab-7924f1d2e71de065b6f'], //overview
        [1, 'tab-6b450decc1cd295a70a'],
        [2, 'tab-19017f87daea3a103ca'], //sustaining places
        [3, 'tab-b57f0800d43fff2925c'],
        [4, 'tab-bd5d2f27b7afd43e2d1'],
      ]),
    []
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = useCallback(
    index => {
      setSearchParams(tabMap.get(index), { replace: true });
      setTabIndex(index);
    },
    [tabMap, setSearchParams]
  );

    useEffect(() => {
      if (searchParams.has(tabMap.get(0))) {
        handleTabsChange(0);
      } else if (searchParams.has(tabMap.get(1))) {
        handleTabsChange(1);
      } else if (searchParams.has(tabMap.get(2))) {
        handleTabsChange(2);
      } else if (searchParams.has(tabMap.get(3))) {
        handleTabsChange(3);
      } else if (searchParams.has(tabMap.get(4))) {
      handleTabsChange(4);
    }
    }, [tabMap, searchParams, handleTabsChange]);

  return (
    <HomeLayout align="center">
      <Tabs
        isFitted
        w="full"
        isLazy
        index={tabIndex}
        onChange={handleTabsChange}
      >
        <TabPanels>
          <TabPanel p={0}>
            <Fade in={true}>
              <Image src={corporateresponsibilityHero} paddingTop="90px" />
            </Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>{/* <Image src={} paddingTop="90px" /> */}</Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>{/* <Image src={} paddingTop="90px" /> */}</Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>{/* <Image src={} paddingTop="90px" /> */}</Fade>
          </TabPanel>
        </TabPanels>

        <TabList>
          <Tab>Overview</Tab>
          <Tab>Empowering People</Tab>
          <Tab>Sustaining Places</Tab>
          <Tab>Responsible Practices</Tab>
          <Tab>Highlights</Tab>
        </TabList>
        <Text fontSize={'3xl'} fontWeight={600} ml="150px" mr="150px" py={4}>
          AT COLUMBIA SPORTSWEAR COMPANY, WE INVEST IN INITIATIVES THAT HAVE A
          POSITIVE IMPACT ON THE PEOPLE WE REACH, THE PLACES WE TOUCH, AND THE
          PRODUCTS WE MAKE.
        </Text>

        <HeroWithLeftMedia
          media={<Image borderRadius={10} src={timBoyle} id="timBoyleImg" />}
          subTitle={
            <Stack>
              <Text fontWeight={'bold'}>
                "One of our core values is to do the right thing, not just for
                our company, but also for our consumers, customers, employees
                and their communities. Here at Columbia, our entire 81-year
                history has been driven by a deep commitment to the people and
                families who live, work and play in the communities where we
                operate and to the scarce resources that we all have a
                responsibility to steward effectively."
              </Text>
              <br />
              <Text fontWeight={'bold'}>– Tim Boyle, CEO </Text>
            </Stack>
          }
        ></HeroWithLeftMedia>
        <HeroWithRightMedia
          media={
            <Image borderRadius={10} src={abelNavarrete} id="abelNavarrete" />
          }
          subTitle={
            <Stack>
              <Text fontWeight={'bold'}>
                "Our Corporate Responsibility team ensures we have the policies,
                programs and resources in place to run our business responsibly,
                to be conscientious stewards of the environment and to have a
                positive impact on our communities."
              </Text>
              <br />
              <Text fontWeight={'bold'}>
                – Abel Navarrete, VP of Corporate Responsibility
              </Text>
            </Stack>
          }
        ></HeroWithRightMedia>

        <TabPanels>
          <TabPanel>{/* <OverviewPanel /> */}</TabPanel>
          <TabPanel>{/* <EmpoweringPeoplePanel /> */}</TabPanel>
          <TabPanel>{/* SustainingPlacesPanel /> */}</TabPanel>
          <TabPanel>{/* <ResponsiblePracticesPanel /> */}</TabPanel>
          <TabPanel>{/* <HighlightsPanel /> */}</TabPanel>
        </TabPanels>
      </Tabs>

      <VStack justify="center" pt={1}>
        <Text fontSize="4xl" fontWeight="bold">
          ENVIRONMENTAL, SOCIAL, & GOVERNANCE REPORTS & DISCLOSURES
        </Text>

        <SimpleGrid align={'center'} columns={2} spacing={10} py={4}>
          <GridCard
            title="2021 Report"
            href="https://s3.amazonaws.com/content.stockpr.com/columbia/db/718/5753/pdf/Columbia_CSR_RY2021_FINAL_.pdf"
            backgroundImage={waterfallCard}
          />
          <GridCard
            title="2020 Report"
            href="https://d1io3yog0oux5.cloudfront.net/_258e51144a7b70f3536dfd884976988a/columbia/db/641/5719/pdf/2020+Corporate+Responsibility+Report.pdf"
            backgroundImage={trailHikeCard}
          />
        </SimpleGrid>
        <Text fontSize="4xl" fontWeight="bold">
          HISTORIC ENVIRONMENTAL, SOCIAL, & GOVERNANCE REPORTS
        </Text>
        <SimpleGrid
          align={'center'}
          columns={{ base: 1, md: 4 }}
          spacing={10}
          py={4}
        >
          <GridCard
            title="2019 Report"
            href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2019_Columbia_Corp_Resp_Report.pdf"
            backgroundImage={snowMountainCard}
          />
          <GridCard 
            title="2018 Report" 
            href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2018_Columbia_Corp_Resp_Report.pdf" 
            backgroundImage={waterCard} />
          <GridCard 
            title="2017 Report" 
            href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2017_Columbia_Corp_Resp_Report.pdf" 
            backgroundImage={forestCard} />
          <GridCard
            title="2016 Report"
            href="https://cscworkday.blob.core.windows.net/hrforms/Recruiting/Career_Site/CR_Reports/2016_Columbia_Corp_Resp_Report.pdf"
            backgroundImage={greenMountainCard}
          />
        </SimpleGrid>
        <Text fontSize="4xl" fontWeight="bold">
          OUR BRAND'S INITIATIVES
        </Text>
        <SimpleGrid align={'center'} columns={2} spacing={10} py={4}>
          <GridCard 
            title="COLUMBIA" 
            href="https://www.columbia.com/corporate-responsibility/" 
            backgroundImage={columbiaCard} />
          <GridCard 
            title="PRANA" 
            href="https://www.prana.com/sustainability.html" 
            backgroundImage={pranaCard} />
          <GridCard
            title="MOUNTAIN HARDWEAR"
            href="https://www.mountainhardwear.com/sustainability.html"
            backgroundImage={mountainHardwearCard}
          />
          <GridCard 
            title="SOREL" 
            href="https://www.sorel.com/about-us_responsibility/" 
            backgroundImage={sorelCard} />
        </SimpleGrid>
      </VStack>
    </HomeLayout>
  );
}
